import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    
    return (
        <footer className="footer">
            <span className="text-gray-500">{t('copyright')}</span>
        </footer>
    )
}
export default Footer
